import { Component, Input, Optional } from '@angular/core';
import { FormGroupDirective, NgForm, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { ItemFactory } from '../../interfaces/form-controls';
import { ErrorRepeatedControlDirective } from '../error-repeated-control.component';

@Component({
  selector: 'forms-input-repeated',
  templateUrl: './input-repeated.component.html',
  styleUrls: ['./input-repeated.component.scss'],
})
export class InputRepeatedComponent extends ErrorRepeatedControlDirective {
  @Input() controlArray: UntypedFormArray;
  @Input() addText = 'FRONTEND.FORMS.INPUT.ADD_FIELD';
  @Input() tooltip: string;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() disableAdd = false;
  @Input() maxFields: number;
  @Input() itemFactory: ItemFactory;

  constructor(
    private fb: UntypedFormBuilder,
    @Optional() _parentForm: NgForm,
    @Optional() _parentFormGroup: FormGroupDirective,
  ) {
    super(_parentForm, _parentFormGroup);
  }

  add(): void {
    if (this.itemFactory) {
      this.controlArray.push(this.itemFactory());
    } else {
      this.controlArray.push(this.fb.control('', this.controlArray.at(0).validator));
    }
  }

  remove(idx: number): void {
    this.controlArray.removeAt(idx);
    this.controlArray.markAsDirty();
  }
}
